{
  "pt": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Entraremos em contato com você em breve.",
        "failure": "Contate-me!"
      }
    }
  }
}
